import {apiSlice} from './apiSlice';

// Define a service using a base URL and expected endpoints
export const sessionNoteApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSessionNotes: builder.query({
      query: (filters) => {
        const qs = Object.keys(filters).reduce((acc, k) => {
          acc.set(k, filters[k]);
          return acc;
        }, new URLSearchParams());
        return `session_note/?${qs}`;
      },
      providesTags: ['SessionNote'],
    }),
    updateSessionNote: builder.mutation({
      query: body => ({
        url: 'session_note/',
        method: 'POST',
        body
      }),
      invalidatesTags: (result, error, arg) => {
        if (error) return [];
        if (result && arg.finalize) return ['Session', 'SessionNote'];
        return ['SessionNote'];
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetSessionNotesQuery,
  useUpdateSessionNoteMutation,
} = sessionNoteApi;
